import ProjectSetUpPageStore from '../../ProjectSetUpPage.store'
import ISetUpStep from './ISetUpStep'

export interface ISetUpNavigationRowProps {
  step: ISetUpStep
  projectSetUpPageStore: ProjectSetUpPageStore
  isShortVersion?: boolean
}

const iconSize = 24
export const iconProps = {
  size: iconSize,
  className: 'row icon-h24 icon-w24 x-center y-center no-grow',
}
